import { Injectable } from '@angular/core';
import { ClientConfigurationService } from '../../configuration/auth/client/client-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class BasicAuthHeaderFactoryService {

  get clientId() {
    return this.clientConfiguration.clientId;
  }

  get clientConfiguration() {
    return this.clientConfigurationService.configuration;
  }

  constructor(private clientConfigurationService: ClientConfigurationService) { }

  createHeader() {
    return {
      Authorization: 'Basic ' + btoa(this.clientId)
    };
  }
}
